import * as React from 'react'
import { Dialog, TextField, 
         DialogTitle, Button, 
         DialogContentText, 
         Grid, Divider, 
         InputAdornment,
         IconButton,
         Typography, } from '@mui/material'
 import CloseIcon from '@mui/icons-material/Close'
 import {PDFDate } from '../misc/dates'
 import axios from 'axios'
 import { axiosErrorHandling} from '../misc/other'
 import { SettlementLetterPDF, getProps } from '../letters/SettlementLetter'
 import { pdf } from '@react-pdf/renderer'
 

 
 



export const ProccRecurPaymentAlert = ({open, accounts, amount, setAmount, onClose, date, setDate}) =>{
    
    const [greenMoneyId, setGreenMoneyID] = React.useState(0)
    const [errMessage, setErrMessage] = React.useState('')
    const [processing, setProcessing] = React.useState(false)

    const file_name = accounts[0].customer_number.toString() + '_SettlementLetter_' + PDFDate + '.pdf'

    const changeDate = (event) =>{
        
        
        setDate(event.target.value)
        
        
       
    }

    const changeMoneyID = (event) =>{
        setGreenMoneyID(event.target.value)
    }

    const changeAmount = (event) =>{
        setAmount(event.target.value)
    }



    let customerInfo = {customer_number: accounts[0].customer_number,
                        street_address_1: accounts[0].street_address_1,
                        street_address_2:accounts[0].street_address_2,
                        city: accounts[0].city,
                        state: accounts[0].state,
                        zip: accounts[0].zip,
                        zip4: accounts[0].zip4,
                        wave_customer_number: ''
    }

    const fillData = [{settlement_amount: accounts[0].settlement_amount, 
                       original_creditor: accounts[0].original_creditor,
                       original_creditor: accounts[0].original_account_number,
                       batch_number: accounts[0].batch_number,
                       balance: 0}]

    const PDFfunction = async() =>{
    
    const PDFprops = await getProps(accounts, customerInfo, Number(accounts[0].settlement_amount).toFixed(2))
    const blob = await pdf(SettlementLetterPDF({...PDFprops})).toBlob()
    

   

   await axios({
        method: 'POST',
        url: 'api/oracle4/upload',
        headers: {'Content-Type': 'application/octet-stream'},
        params:{fileName: file_name,
                customer_number: accounts[0].customer_number,
                autogenerated: 1,
                email: accounts[0].email},
        data: blob
        
    }).then(async (response)=>{
       
        if (response.status===200){

             await axios({
                method: 'POST',
                url:'api/oracle5/recurringdocupdate',
                data: {customer_number: customerInfo.customer_number,
                       status: 'PAID', 
                       data: fillData,
                       file_name: file_name}
            
              }).then( async result=>{
               
                if (result.status===200){
                    let newNumberOfPayments = accounts[0].number_of_payments - 1
                            
               
                     await axios({
                            method: 'POST',
                            url: 'api/oracle3/paidrec',
                            data: { balance: '0.00',
                                    account_status: 'PAID',
                                    id: greenMoneyId,
                                    date: date,
                                    amount: amount,
                                    transactions: accounts[0].transactionIDs,
                                    originalAccountNumber: accounts[0].original_account_number,
                                    batchNumber: accounts[0].batch_number,
                                    number_of_payments: newNumberOfPayments,


                            }
                        }).then(result1=>{
                            
                            if(result1.data==="Payment Processed"){
                                setProcessing(false)
                                setErrMessage('Payment Processed Successfully you can close the Dialogue box.')
                                
                            }
                        }).catch(err=>{
                    
                    setProcessing(false)
                    throw err
                })
                    
                }else{
                                    setProcessing(false)
                                    let newErrorMessage = axiosErrorHandling(result)
                                    setErrMessage(newErrorMessage)
                                    
                                }
              })
              .catch(errors=>{
                let errorMess = 'Here are the errors in the confirmation call:' + errors
                setProcessing(false)
                setErrMessage(errorMess)
                

            })
        } else {
            let errMess = 'Here is the error in response from the upload call: '+  response.statusText
            setProcessing(false)
            setErrMessage(errMess)
            
        }
    }).catch(error=>{
        let errorMessage = 'Here are the errors with the axios upload call: '+ error
        setProcessing(false)
        setErrMessage(errorMessage)
       
    })

    

    

}

   const closeClick = () =>{
    onClose()
    setErrMessage('')
    setGreenMoneyID(0)
   } 

    const onProcessClick = async () =>{
        setProcessing(true)
        try{

               

        
               await axios({
                    method: 'POST',
                    url: 'api/oracle6/processrecurringtransaction',
                    data: {account: accounts,
                           customer_number: accounts[0].customer_number,
                           total: amount,
                           number_of_payments: accounts[0].number_of_payments - 1, 
                           id: greenMoneyId,
                           date: date
                     }
                }).then( async results=>{
                        
                    if(results.data==='Transaction Posted'){
                            let newAccountBallance = accounts[0].account_balance - amount
                            let newNumberOfPayments = accounts[0].number_of_payments - 1
                            let accountStatus;
               
                         
                if (newNumberOfPayments>0){
                        accountStatus = 'Recurring'
                         await axios({
                            method: 'POST',
                            url: 'api/oracle3/updaterec',
                            data: { balance: newAccountBallance,
                                    account_status: accountStatus,
                                    id: greenMoneyId,
                                    date: date,
                                    amount: amount,
                                    transactions: accounts[0].transactionIDs,
                                    originalAccountNumber: accounts[0].original_account_number,
                                    batchNumber: accounts[0].batch_number,
                                    number_of_payments: newNumberOfPayments,


                            }
                        }).then(result1=>{
                            
                            if(result1.data==="Payment Processed"){
                                setProcessing(false)
                                setErrMessage('Payment Processed Successfully you can close the Dialogue box.')
                                
                            }
                        }).catch(err=>{
                    
                    setProcessing(false)
                    throw err
                })


                } else {
                    accountStatus = 'PAID'
                    await PDFfunction()
                }

                
                      
                        
                    }
                }).catch(err=>{
                    
                    setProcessing(false)
                    throw err
                })

            } 
        
    catch(err){
        let message = axiosErrorHandling(err)
        
        setErrMessage(message)
        setProcessing(false)
    }
}

    return (

        <Dialog open={open} fullWidth>
            <DialogTitle color='primary' justifyContent='center' textAlign='center' >Process Recurring Payment</DialogTitle>
            <IconButton
                        aria-label="close"
                        onClick={closeClick}
                        sx={{
                          position: 'absolute',
                          right: 8,
                          top: 8,
                          color: (theme) => theme.palette.grey[500],
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
            <Divider />
            <DialogContentText color='secondary' sx={{mb: 1, mt: 1, ml: 1}}>
                Enter payment information below:
            </DialogContentText>
            <Divider sx={{mb: 1}}/>
            <Grid container direction='column'>
                <Grid sx={{mb: 1, ml: 20, width: 210}} >
                    <TextField
                        fullWidth
                        value={date}
                        onChange={changeDate}
                        label='Date'
                        variant='outlined'
                        id='Date'
                        format='yyyy-MM-dd'
                        type='date'
                        slotProps={{inputLabel:{shrink: true}}}
                      /> 

                </Grid>
                <Grid sx={{mb: 1, ml: 20}}>
                    <TextField
                    variant='outlined' 
                    type='text'
                    id='paymentID'
                    name='paymentID'
                    label='Green Money ID'
                    value={greenMoneyId}
                    onChange={changeMoneyID}
                    />
                </Grid>
                <Grid sx={{mb: 1, ml: 20, width: 210}}>
                    <TextField
                    fullWidth 
                    variant='outlined'
                    type='number'
                    id='amount'
                    name='amount'
                    label='Amount'
                    slotProps={{input:{ startAdornment: <InputAdornment position='start'>$</InputAdornment> }}}
                    value={amount}
                    onChange={changeAmount}
                    />
                </Grid>
                
                <Grid sx={{mt: 2, mr: 1, mb: 2, alignSelf: 'flex-end'}}>
                    <Button variant='contained' onClick={onProcessClick} loading={processing}>Process</Button>
                </Grid>
                 <Grid alignSelf='center'>      
                       <Typography color='secondary' variant='body1'>{errMessage}</Typography>
                 </Grid>         
            </Grid>

        </Dialog>
    )


}